var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhiteTransparentBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77138 16.22C5.77138 15.144 5.34041 14.1329 4.5553 13.373L3.08197 11.9438L0 14.935L2.63095 17.4871C3.32418 18.1595 3.70838 19.054 3.71005 20.0035C3.70838 20.9498 3.32418 21.8426 2.63095 22.515L0 25.0671L3.08364 28.0566L4.55697 26.6275C5.34041 25.8675 5.77305 24.8564 5.77305 23.7805V16.2183L5.77138 16.22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 23.7836V16.2165C16.3636 15.1438 15.9326 14.1327 15.1475 13.3728L8.37884 6.80713L5.29688 9.79668L13.2231 17.4852C13.9164 18.1577 14.3006 19.0521 14.3022 20.0017C14.3006 20.9496 13.9164 21.8408 13.2231 22.5132L5.29688 30.2018L8.37884 33.1913L15.1475 26.6257C15.9326 25.8657 16.3636 24.8562 16.3636 23.7819",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9912 20.0275V20.0211C27.9912 17.7445 27.9945 15.4646 27.9995 13.9642C28.0029 12.8478 27.5736 11.814 26.7918 11.0557L15.396 0L11.123 4.14486L23.6814 16.3267C24.6937 17.3086 25.2533 18.613 25.2567 20C25.2533 21.3886 24.6937 22.693 23.6814 23.675L11.123 35.8551L15.396 40L26.7918 28.946C27.5752 28.1876 28.0045 27.1539 27.9995 26.0374C27.9945 24.5499 27.9912 22.2944 27.9912 20.034V20.0275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteTransparentBg);
export default __webpack_public_path__ + "static/media/logo-white-transparent-bg.5d2055b31b0cb7cb648fe172d8b2c7c7.svg";
export { ForwardRef as ReactComponent };